import type {
    GetMoreNavigationTreeItemsArgs,
    OpenNavigationTreeNodeArgs,
} from '~shared/schema/wiki/actions/navigation-tree';

import {i18n} from '~ui/components/NavigationTree/i18n';
import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';

import {NavigationItemLoadMoreType} from './types';

type LoadNavigationTreeData = Omit<OpenNavigationTreeNodeArgs, 'openAroundNodeSlug'>;

export const loadNavigationTree = createThunk(
    'navigation-tree/load-tree',
    (data: LoadNavigationTreeData, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.openNavigationTreeNode(data).catch(
            makeThunkErrorHandler({
                name: 'navigation-tree-get-error',
                title: i18n('get-tree-error'),
            }),
        );
    },
);

type LoadNavigationTreeNodeData = Omit<OpenNavigationTreeNodeArgs, 'breadcrumbsBranchSlug'>;

// same request as above, however, we make 2 different handlers
// for them in slice
export const loadNavigationTreeNode = createThunk(
    'navigation-tree/load-tree-node',
    (data: LoadNavigationTreeNodeData, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.openNavigationTreeNode(data).catch(
            makeThunkErrorHandler({
                name: 'navigation-tree-get-error',
                title: i18n('get-tree-error'),
            }),
        );
    },
);

interface LoadMoreNavigationItemsOptions extends GetMoreNavigationTreeItemsArgs {
    type: NavigationItemLoadMoreType;
}

export const getMoreNavigationTreeItems = createThunk(
    'navigation-tree/load-more',
    (data: LoadMoreNavigationItemsOptions, thunkAPI) => {
        const {sdk} = thunkAPI.extra;

        return sdk.wiki.getMoreNavigationTreeItems(data).catch(
            makeThunkErrorHandler({
                name: 'navigation-tree-get-error',
                title: i18n('get-tree-error'),
            }),
        );
    },
);
